// Re-export all types
export type { Language, GameItem, TierPlanTranslation } from './types'
export type { SubscriptionTranslations } from './types'
export type { ProfileTranslations } from './types'
export type { AuthTranslations } from './types'
export type { CutleryTranslations } from './types'
export type { WordMatchTranslations } from './types'
export type { WordSearchTranslations } from './types'
export type { ShoppingListTranslations } from './types'
export type { MoneyTranslations } from './types'
export type { DownloadsTranslations } from './types'
export type { SudokuTranslations } from './types'
export type { MathsTranslations } from './types'
export type { PillboxTranslations } from './types'
export type { AttentionTranslations } from './types'
export type { WhatsMissingTranslations } from './types'
export type { RomanNumbersTranslations } from './types'
export type { CrosswordsTranslations } from './types'
export type { HoursTranslations } from './types'
export type { SynonymsTranslations } from './types'
export type { PuzzleTranslations } from './types'
export type { ChessTranslations } from './types'
export type { NumTargetTranslations } from './types'
export type { AdminHubTranslations } from './types'
export type { ProfessionalTranslations } from './types'
export type { Translations } from './types'

// Re-export translation objects
export { es } from './es'
export { en } from './en'

// Assemble the LANGUAGES map (same shape as before)
import type { Language, Translations } from './types'
import { es } from './es'
import { en } from './en'

export const LANGUAGES: Record<Language, Translations> = { es, en }
